module.exports = __webpack_public_path__ + "static/media/pago-seguro.44a7e88b.png";